import DatePicker from "react-datepicker";

const DateControl = (
    {
        id,
        label,
        placeholder,
        value,
        onChange,
        isReadOnly,
        minDate,
        maxDate, 
        isRequired
    }: IDateControl
) => {

    const onChangeDate = (date: any) => onChange(id, date);

    return (
        <>
            <div className="lbl-input-cvs mt-10 mb-5">
                <span> {label} </span>
            </div>
            <DatePicker
                className="date-cvs"
                locale="es"
                selected={value}
                onChange={onChangeDate}
                dateFormat='dd/MM/yyyy'
                readOnly={isReadOnly}
                minDate={minDate}
                maxDate={maxDate}
                placeholderText={placeholder}
                id={id}
                autoComplete="off"
                required={isRequired}
                title="Campo requerido"
            />
        </>

    );

}

export { DateControl };